import { render, staticRenderFns } from "./right-table.vue?vue&type=template&id=e05adbec&scoped=true&"
import script from "./right-table.vue?vue&type=script&lang=ts&"
export * from "./right-table.vue?vue&type=script&lang=ts&"
import style0 from "./right-table.vue?vue&type=style&index=0&id=e05adbec&prod&lang=scss&"
import style1 from "./right-table.vue?vue&type=style&index=1&id=e05adbec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05adbec",
  null
  
)

export default component.exports